import React, { useState } from "react";
import {
  Box,
  Button,
  Typography,
  Divider,
  Paper,
  TextField,
  Alert,
  IconButton,
  Grid,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DashboardHeader from "@components/Header/DashboardHeader";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { AppDispatch } from "@store/store";
import {
  fetchApplicationDetails,
  fetchApplicationDetailsRow,
  fetchbankguaranteedetailsThunk,
  getTransactionStatusThunk,
} from "../redux/thunk/application-detailThunk";
import {
  FeesDetailsThunk,
  FeesDetailsComponentThunk,
} from "@modules/application-section/application-details/redux/services/thunk/DetailsThunk";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import {
  postPayloadBkpayThunk,
  ZeroFeeBgUploadThunk,
} from "@store/thunk/PaymentThunk";
import type { RootReducerType } from "@store/store";
import { getUploadSignedURLThunk } from "../redux/thunk/application-detailThunk";
import { uploadToS3Thunk } from "@store/thunk/UploadS3Thunk";
import { useNavigate } from "react-router-dom";
import PaymentLoader from "../../../utils/PaymentLoader";
import CircleRateCard from "./CircleRateCard";
import { openFileBySignedUrl } from "../../../utils/getViewSignedUrlHandler";
import { getFileSignedURLThunk as getAccessSignedURLThunk } from "@modules/stepper/redux/thunk/documentThunk";
import DownloadIcon from "@mui/icons-material/Download";
import { getFileSignedURLThunk as getRowSignedURLThunk } from "@modules/stepper-row/redux/thunk/documentThunk";
import { productionCheck } from "@components/buttonGroupView/utils";
import { genericUploadThunk } from "../redux/thunk/uploadThunk";
import { RemoveRedEye } from "@mui/icons-material";

export const LicenseFee: React.FC = () => {
  const [showAlert, setShowAlert] = useState(true);
  const [bankGuaranteeNumber, setBankGuaranteeNumber] = useState("");
  const [bankName, setBankName] = useState("");
  const [bankGuaranteeDoc, setBankGuaranteeDoc] = useState<string | null>(null);
  const [branchAddress, setBranchAddress] = useState("");
  const [bgIssuanceDate, setBgIssuanceDate] = useState("");
  const [bgValidityDate, setBgValidityDate] = useState("");
  const [bgClaimDate, setBgClaimDate] = useState("");
  const issuanceDayjs = bgIssuanceDate ? dayjs(bgIssuanceDate) : null;
  const validityDayjs = bgValidityDate ? dayjs(bgValidityDate) : null;
  const bgClaimDateDayJS = bgClaimDate ? dayjs(bgClaimDate) : null;

  // Input validation functions
  const validateBankName = (value: string) => {
    return value.replace(/[^a-zA-Z\s]/g, "");
  };

  const validateBankGuaranteeNumber = (value: string) => {
    return value.replace(/[^a-zA-Z0-9]/g, "");
  };

  const validateBranchAddress = (value: string) => {
    return value.replace(/[^a-zA-Z0-9\s,.\/#-]/g, "");
  };
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();
  const params = new URLSearchParams(location.search);
  const row = params.get("row");
  const access = params.get("access");
  const applicationId = row ? row : access ? access : null;

  const [applicantdata, setapplicantData] = React.useState<any>(null);
  // const [FeeDetailsComponent, setFeeDetailsComponent] = React.useState<any>({});
  const [provisionalFee, setProvisionalFee] = React.useState<any>({});
  const { profile } = useSelector((state: RootReducerType) => state.profile);
  const [bankGauranteeURL, setbankGauranteeURL] = React.useState<any>(null);
  const [bgDetails, setBGDetails] = React.useState<any>(null);
  const [showLoader, setShowLoader] = useState(false);
  const [openClaimDate, setOpenClaimDate] = React.useState(false);
  const [openIssuanceDate, setOpenIssuanceDate] = React.useState(false);
  const [openValidityDate, setOpenValidityDate] = React.useState(false);
  const navigate = useNavigate();

  const fetchTransactionStatus = async (application_id: any) => {
    try {
      const res = await dispatch(
        getTransactionStatusThunk(application_id),
      ).unwrap();
      if (res?.status) {
        navigate("/esign?" + (row ? `row=${row}` : `access=${access}`));
      } else {
        if (row) {
          fetchROW(row);
        } else if (access) {
          fetchAccess(access);
        }
      }
    } catch (error) {
      console.error("Error fetching transaction status:", error);
    }
  };

  React.useEffect(() => {
    fetchTransactionStatus(row || access);
  }, [row, access]);

  const fetchROW = async (id: any) => {
    try {
      const res = await dispatch(fetchApplicationDetailsRow(id)).unwrap();
      setapplicantData(res);
    } catch (error) {
      console.error("Error fetching ROW details:", error);
    }
  };

  const fetchAccess = async (id: any) => {
    try {
      const res = await dispatch(fetchApplicationDetails(id)).unwrap();
      setapplicantData(res);
    } catch (error) {
      console.error("Error fetching ROW details:", error);
    }
  };

  // React.useEffect(() => {
  //   const fetchFeesComponent = async () => {
  //     if (applicationId && row) {
  //       try {
  //         const feesComponentAmount = await dispatch(
  //           FeesDetailsComponentThunk({ applicationId }),
  //         ).unwrap();
  //         if (feesComponentAmount) {
  //           setFeeDetailsComponent(feesComponentAmount || {});
  //         }
  //       } catch (error) {
  //         console.error("Error fetching Fees Component details:", error);
  //       }
  //     }
  //   };
  //   fetchFeesComponent();
  // }, [applicationId]);

  React.useEffect(() => {
    const fetchFeesAmount = async () => {
      if (applicationId) {
        try {
          const feesAmount = await dispatch(
            FeesDetailsThunk({ applicationId }),
          ).unwrap();
          setProvisionalFee(feesAmount || {});
        } catch (error) {
          console.error("Error fetching Fees details:", error);
        }
      }
    };
    fetchFeesAmount();
  }, [applicationId, dispatch]);

  const handlePayNow = async () => {
    if (!applicationId) {
      toast.error("Application ID is missing.");
      return;
    }
    setShowLoader(true);
    await handlePostBase64();
  };

  const handlePostBase64 = async () => {
    if (!applicationId || !bankGauranteeURL) return;

    const fullName = profile?.name || "";
    const nameParts = fullName
      .trim()
      .split(" ")
      .filter((part) => part.length > 0);
    const firstName = nameParts?.length > 0 ? nameParts?.[0] : "";
    const lastName = nameParts?.length > 1 ? nameParts?.slice(1).join(" ") : "";
    let mobileNumber = profile?.mobile_number || "";
    if (mobileNumber.startsWith("+91")) {
      mobileNumber = mobileNumber.slice(3);
    }
    try {
      const bkPayload = {
        application_id: applicationId,
        FirstName: firstName || "",
        LastName: lastName || "",
        Address1: profile?.address || "",
        Address2: "",
        // PostalCode: "",
        // City: "",
        // StateRegion: "",
        // State: "",
        PostalCode: profile?.pincode || "",
        City: profile?.district || "",
        StateRegion: profile?.district || "",
        State: profile?.state || "",
        CountryCode: "INDIA",
        MobileNumber: mobileNumber,
        payment_stage: 2,
        bankGuarantee_no: bankGuaranteeNumber,
        bg_bank_name: bankName,
        bg_issue_date: bgIssuanceDate,
        bg_validity_date: bgValidityDate,
        bg_claim_date: bgClaimDate,
        branch_address: branchAddress,
        bankGuaranteeDocument: {
          fileName: bankGuaranteeDoc || "",
          objectKey: bankGauranteeURL || "",
        },
      };

      const getSignedBase64: any = await dispatch(
        postPayloadBkpayThunk(bkPayload),
      ).unwrap();

      if (getSignedBase64.success === false) {
        toast.error(
          getSignedBase64.message ||
            "Failed to initiate payment. Please try again.",
        );
        setShowLoader(false);
        return;
      }
      const form = document.createElement("form");
      form.method = "POST";
      form.action =
        process.env.REACT_APP_BHARATKOSH_URL || "https://bharatkosh.gov.in/";
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = "bharrkkosh";
      input.value = getSignedBase64;

      form.appendChild(input);
      document.body.appendChild(form);
      form.submit();
    } catch (error) {
      console.error("Error posting base64:", error);
      setShowLoader(false);
    }
  };

  const handleViewFile = (
    document_name?: string,
    isRow?: boolean,
    dispatch?: any,
  ) => {
    if (!dispatch) return;

    return openFileBySignedUrl({
      document_name,
      dispatch,
      getSignedUrlThunk: isRow ? getRowSignedURLThunk : getAccessSignedURLThunk,
    });
  };

  const handleSubmit = async () => {
    if (!applicationId) {
      toast.error("Application ID is missing.");
      return;
    }
    try {
      const payload = {
        application_id: applicationId,
        bankGuarantee_no: bankGuaranteeNumber,
        bg_bank_name: bankName,
        bg_issue_date: bgIssuanceDate,
        bg_validity_date: bgValidityDate,
        bg_claim_date: bgClaimDate,
        branch_address: branchAddress,
        bankGuaranteeDocument: {
          fileName: bankGuaranteeDoc || "",
          objectKey: bankGauranteeURL || "",
        },
      };

      const response = await dispatch(ZeroFeeBgUploadThunk(payload)).unwrap();
      if (response?.success) {
        navigate("/esign?" + (row ? `row=${row}` : `access=${access}`));
      } else {
        toast.error("Submission failed. Please try again.");
      }
    } catch (error) {
      console.error(
        "Error submitting electronic Bank Guarantee (e-BG):",
        error,
      );
      toast.error("Submission failed. Please try again.");
    }
  };

  React.useEffect(() => {
    if (applicationId) {
      dispatch(fetchbankguaranteedetailsThunk(applicationId as any)).then(
        (res: any) => {
          if (res.payload) {
            setBGDetails(res.payload);
          }
        },
      );
    }
  }, [applicationId, dispatch]);

  React.useEffect(() => {
    if (bgDetails) {
      if (bgDetails.bank_guarantee_no) {
        setBankGuaranteeNumber(bgDetails.bank_guarantee_no);
      }
      if (bgDetails.bg_bank_name) {
        setBankName(bgDetails.bg_bank_name);
      }
      if (bgDetails.bg_isssue_date) {
        setBgIssuanceDate(bgDetails.bg_isssue_date);
      }
      if (bgDetails.bg_validity_date) {
        setBgValidityDate(bgDetails.bg_validity_date);
      }
      if (bgDetails.bg_claim_date) {
        setBgClaimDate(bgDetails.bg_claim_date);
      }
      if (bgDetails.branch_address) {
        setBranchAddress(bgDetails.branch_address);
      }
      if (bgDetails.bank_guarantee_document) {
        setbankGauranteeURL(bgDetails.bank_guarantee_document.upload_path);
      }
      if (bgDetails.bank_guarantee_document) {
        setBankGuaranteeDoc(bgDetails.bank_guarantee_document?.document_name);
      }
    }
  }, [bgDetails]);

  // console.log("FeeDetailsComponent:", FeeDetailsComponent);

  return (
    <Box>
      <div className="page-content">
        <PaymentLoader open={showLoader} />
        <Box className="app-details-card">
          <Box className="application-banner">
            <Box>
              {/* Header */}
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <ArrowBackIcon
                  onClick={() => navigate(`/application-dashboard`)}
                  sx={{ mr: 1, fontSize: 22, color: "#222" }}
                />
                <Typography variant="h6" fontWeight={700} sx={{ flex: 1 }}>
                  Fee Payment
                </Typography>
                <Box sx={{ textAlign: "right" }}>
                  <Typography variant="body2" fontWeight={600}>
                    Application No:
                  </Typography>
                  <Typography variant="body2">
                    {applicantdata?.application_code}
                  </Typography>
                </Box>
              </Box>

              <Divider sx={{ mb: 2 }} />

              {/* Success Alert */}
              {showAlert && (
                <Alert
                  severity="success"
                  icon={
                    <Box
                      sx={{
                        width: 26,
                        height: 26,
                        borderRadius: "50%",
                        background: "#fff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <NotificationsIcon
                        sx={{ color: "#78af7b", fontSize: 20 }}
                      />
                    </Box>
                  }
                  sx={{
                    mb: 3,
                    alignItems: "center",
                    backgroundColor: "#78af7b",
                    color: "#fff",
                    borderRadius: 2,
                    height: "fit-content",
                  }}
                  action={
                    <IconButton
                      size="small"
                      onClick={() => setShowAlert(false)}
                    >
                      <CloseIcon fontSize="small" sx={{ color: "#fff" }} />
                    </IconButton>
                  }
                >
                  <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
                    Congratulations! Your Application ID:{" "}
                    {applicantdata?.application_code} has received authority
                    approval. Please complete the payment to proceed further.
                  </Typography>
                </Alert>
              )}

              <Alert severity="error" sx={{ mb: 2, fontSize: "14px" }}>
                <strong>Important:</strong> Please wait for 20 minutes if you
                have recently attempted the payment. If the amount has been
                deducted but an Application Status was not updated, contact our
                support team at{" "}
                <a
                  href="mailto: support-rmp@gov.in"
                  style={{ textDecoration: "underline" }}
                >
                  {" "}
                  support-rmp@gov.in
                </a>{" "}
                for assistance.
              </Alert>

              {/* Main Content */}
              <Grid container spacing={2} className="license-fee-main">
                {/* Left: electronic Bank Guarantee (e-BG) */}
                <Grid item xs={12} md={8}>
                  <Paper
                    sx={{ p: 3, borderRadius: 2, pt: 1 }}
                    className="license-fee-left"
                  >
                    {applicantdata?.circle_rate_apl &&
                      applicantdata?.circle_rate &&
                      applicantdata?.circle_rate_apl !==
                        applicantdata?.circle_rate && (
                        <CircleRateCard
                          circle_rate_appl={applicantdata?.circle_rate_apl}
                          circle_rate={applicantdata?.circle_rate}
                        />
                      )}
                    <Typography
                      variant="h6"
                      fontWeight={700}
                      mb={2}
                      fontSize={22}
                      color="#344054"
                    >
                      electronic Bank Guarantee (e-BG)
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        color: "#667085",
                        mb: 2,
                        display: "flex",
                        alignItems: "flex-start",
                        fontFamily: "Inter",
                        fontWeight: 500,
                        fontSize: "14px",
                        lineHeight: "20px",
                        letterSpacing: "-0.5%",
                      }}
                    >
                      <span
                        style={{
                          fontWeight: 500,
                          marginRight: "6px",
                          fontSize: "16px",
                          lineHeight: "20px",
                        }}
                      >
                        ⓘ
                      </span>
                      A Performance electronic Bank Guarantee (e-BG) (BG) of ₹
                      {provisionalFee?.BankGuarantee?.toLocaleString("en-IN")}{" "}
                      is hereby stipulated as a mandatory condition for the
                      processing of the application.
                    </Typography>

                    {/* BG Calculation Box */}
                    {row && (
                      <Box
                        sx={{
                          p: 2,
                          border: "1px dashed #6b7cff",
                          borderRadius: 2,
                          background: "#f7faff",
                          mb: 2,
                        }}
                      >
                        <Typography fontWeight={600} fontSize={14} mb={1}>
                          electronic Bank Guarantee (e-BG) Calculation Formula:
                        </Typography>

                        <Typography fontSize={13}>
                          electronic Bank Guarantee (e-BG) Amount = Right of Use
                          (meter) x Rate based on Utility Dimension (Rs./meter)
                        </Typography>

                        <Box
                          sx={{ borderBottom: "1px dotted #6b7cff", my: 1.5 }}
                        />

                        <Typography fontSize={13} mt={1}>
                          electronic Bank Guarantee (e-BG) Amount ={" "}
                          <b>₹{provisionalFee?.BankGuarantee}</b>
                        </Typography>
                      </Box>
                    )}

                    {/* Row 1: Bank Name + BG Number */}
                    <Grid container spacing={2} mb={2}>
                      <Grid item xs={12} sm={6}>
                        <Typography fontWeight={500} mb={1}>
                          Bank Name <span style={{ color: "#d32f2f" }}>*</span>
                        </Typography>
                        <TextField
                          required
                          fullWidth
                          size="small"
                          placeholder="Enter the name of the Bank"
                          value={bankName}
                          onChange={(e) =>
                            setBankName(validateBankName(e.target.value))
                          }
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography fontWeight={500} mb={1}>
                          electronic Bank Guarantee (e-BG) Number{" "}
                          <span style={{ color: "#d32f2f" }}>*</span>
                        </Typography>
                        <TextField
                          required
                          fullWidth
                          size="small"
                          placeholder="Enter Number"
                          value={bankGuaranteeNumber}
                          onChange={(e) =>
                            setBankGuaranteeNumber(
                              validateBankGuaranteeNumber(e.target.value),
                            )
                          }
                        />
                      </Grid>
                    </Grid>

                    {/* Row 2: Issuance Date + Validity Date */}
                    <Grid container spacing={2} mb={2}>
                      <Grid item xs={12} sm={6}>
                        <Typography fontWeight={500} mb={1}>
                          electronic Bank Guarantee (e-BG) Issuance Date{" "}
                          <span style={{ color: "#d32f2f" }}>*</span>
                        </Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            open={openIssuanceDate}
                            onOpen={() => setOpenIssuanceDate(true)}
                            onClose={() => setOpenIssuanceDate(false)}
                            value={issuanceDayjs}
                            format="DD/MM/YYYY"
                            onChange={(newValue) => {
                              if (newValue) {
                                setBgIssuanceDate(newValue.toISOString());
                                setBgValidityDate(""); // reset validity date
                              } else {
                                setBgIssuanceDate("");
                              }
                            }}
                            maxDate={dayjs()}
                            slotProps={{
                              textField: {
                                size: "small",
                                fullWidth: true,
                                placeholder:
                                  "electronic Bank Guarantee (e-BG) Issuance Date",
                                inputProps: {
                                  readOnly: true,
                                },
                                onClick: () => {
                                  setOpenIssuanceDate(true);
                                },
                              },
                              popper: { sx: { zIndex: 20000 } },
                            }}
                          />
                        </LocalizationProvider>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography fontWeight={500} mb={1}>
                          electronic Bank Guarantee (e-BG) Validity Date{" "}
                          <span style={{ color: "#d32f2f" }}>*</span>
                        </Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            open={openValidityDate}
                            onOpen={() => setOpenValidityDate(true)}
                            onClose={() => setOpenValidityDate(false)}
                            value={validityDayjs}
                            format="DD/MM/YYYY"
                            disabled={!issuanceDayjs}
                            minDate={issuanceDayjs || undefined}
                            maxDate={
                              issuanceDayjs
                                ? issuanceDayjs.add(row ? 2 : 4, "year")
                                : undefined
                            }
                            onChange={(newValue) => {
                              if (newValue) {
                                setBgValidityDate(newValue.toISOString());
                              } else {
                                setBgValidityDate("");
                              }
                            }}
                            slotProps={{
                              textField: {
                                size: "small",
                                fullWidth: true,
                                inputProps: {
                                  readOnly: true,
                                },
                                onClick: () => {
                                  if (issuanceDayjs) {
                                    setOpenValidityDate(true);
                                  }
                                },
                                placeholder: issuanceDayjs
                                  ? "electronic Bank Guarantee (e-BG) Validity Date"
                                  : "Select Issuance Date first",
                                error: !issuanceDayjs,
                                helperText:
                                  !issuanceDayjs && "Issuance Date is required",
                                FormHelperTextProps: {
                                  sx: {
                                    fontSize: "0.9rem",
                                    fontWeight: 500,
                                  },
                                },
                              },
                              popper: { sx: { zIndex: 20000 } },
                            }}
                          />
                        </LocalizationProvider>
                      </Grid>
                    </Grid>

                    {/* Row 3: Claim Date + Branch Address */}
                    {/* <Grid container spacing={2} mb={2}>
                      <Grid item xs={12} sm={6}>
                        <Typography fontWeight={500} mb={1}>
                          electronic Bank Guarantee (e-BG) Claim Date{' '}
                          <span style={{ color: '#d32f2f' }}>*</span>
                        </Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            open={openClaimDate}
                            onOpen={() => setOpenClaimDate(true)}
                            onClose={() => setOpenClaimDate(false)}
                            value={bgClaimDateDayJS}
                            format="DD/MM/YYYY"
                            disabled={!issuanceDayjs}
                            minDate={issuanceDayjs || undefined}
                            maxDate={
                              issuanceDayjs
                                ? issuanceDayjs.add(3, 'year')
                                : undefined
                            }
                            onChange={(newValue) => {
                              if (newValue) {
                                setBgClaimDate(newValue.toISOString());
                              } else {
                                setBgClaimDate("");
                              }
                            }}
                            slotProps={{
                              textField: {
                                size: 'small',
                                inputProps: {
                                  readOnly: true,
                                },
                                onClick: () => {
                                  if (issuanceDayjs) {
                                    setOpenClaimDate(true);
                                  }
                                },
                                fullWidth: true,
                                placeholder: issuanceDayjs
                                  ? 'electronic Bank Guarantee (e-BG) Claim Date'
                                  : 'Select Issuance Date first',
                                error: !issuanceDayjs,
                                helperText:
                                  !issuanceDayjs && 'Issuance Date is required',
                                FormHelperTextProps: {
                                  sx: {
                                    fontSize: '0.9rem',
                                    fontWeight: 500,
                                  },
                                },
                              },
                              popper: { sx: { zIndex: 20000 } },
                            }}
                          />
                        </LocalizationProvider>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography fontWeight={500} mb={1}>
                          Branch Address{' '}
                          <span style={{ color: '#d32f2f' }}>*</span>
                        </Typography>
                        <TextField
                          required
                          fullWidth
                          size="small"
                          placeholder="Enter Branch Address"
                          value={branchAddress}
                          onChange={(e) =>
                            setBranchAddress(
                              validateBranchAddress(e.target.value),
                            )
                          }
                        />
                      </Grid>
                    </Grid> */}
                    {/* Row 3: Claim Date + Branch Address */}
                    <Grid container spacing={2} mb={2}>
                      <Grid item xs={12} sm={6}>
                        <Typography fontWeight={500} mb={1}>
                          electronic Bank Guarantee (e-BG) Claim Date{" "}
                          <span style={{ color: "#d32f2f" }}>*</span>
                        </Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            open={openClaimDate}
                            onOpen={() => setOpenClaimDate(true)}
                            onClose={() => setOpenClaimDate(false)}
                            value={bgClaimDateDayJS}
                            format="DD/MM/YYYY"
                            disabled={!issuanceDayjs || !validityDayjs}
                            minDate={issuanceDayjs || undefined}
                            maxDate={
                              issuanceDayjs
                                ? row
                                  ? issuanceDayjs.add(24, "month")
                                  : issuanceDayjs.add(4, "year")
                                : undefined
                            }
                            onChange={(newValue) => {
                              if (newValue) {
                                setBgClaimDate(newValue.toISOString());
                              } else {
                                setBgClaimDate("");
                              }
                            }}
                            slotProps={{
                              textField: {
                                size: "small",
                                inputProps: {
                                  readOnly: true,
                                },
                                onClick: () => {
                                  if (issuanceDayjs && validityDayjs) {
                                    setOpenClaimDate(true);
                                  }
                                },
                                fullWidth: true,
                                placeholder:
                                  issuanceDayjs && validityDayjs
                                    ? "electronic Bank Guarantee (e-BG) Claim Date"
                                    : !issuanceDayjs
                                      ? "Select Issuance Date first"
                                      : "Select Validity Date first",
                                error: !issuanceDayjs || !validityDayjs,
                                helperText: !issuanceDayjs
                                  ? "Issuance Date is required"
                                  : !validityDayjs
                                    ? "Validity Date is required"
                                    : "",
                                FormHelperTextProps: {
                                  sx: {
                                    fontSize: "0.9rem",
                                    fontWeight: 500,
                                  },
                                },
                              },
                              popper: { sx: { zIndex: 20000 } },
                            }}
                          />
                        </LocalizationProvider>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography fontWeight={500} mb={1}>
                          Branch Address{" "}
                          <span style={{ color: "#d32f2f" }}>*</span>
                        </Typography>
                        <TextField
                          required
                          fullWidth
                          size="small"
                          placeholder="Enter Branch Address"
                          value={branchAddress}
                          onChange={(e) =>
                            setBranchAddress(
                              validateBranchAddress(e.target.value),
                            )
                          }
                        />
                      </Grid>
                    </Grid>

                    {/* Upload */}
                    <Box>
                      <Typography fontWeight={500} mb={1}>
                        electronic Bank Guarantee (e-BG) Document{" "}
                        <span style={{ color: "#d32f2f" }}>*</span>
                      </Typography>

                      <Button
                        variant="contained"
                        component="label"
                        disabled={provisionalFee?.BankGuarantee === 0}
                        sx={{
                          bgcolor: "#4B2670",
                          color: "#fff",
                          mb: 1,
                          px: 3,
                          borderRadius: 2,
                          boxShadow: "none",
                        }}
                      >
                        + Upload
                        <input
                          type="file"
                          hidden
                          disabled={provisionalFee?.BankGuarantee === 0}
                          accept=".pdf"
                          onChange={async (e) => {
                            if (!e.target.files?.length) {
                              toast.error("Please select a file.");
                              return;
                            }
                            const fileInput = e.target;
                            const file = fileInput.files?.[0];
                            if (!file) {
                              toast.error("Please select a file.");
                              return;
                            }
                            if (file.size > 21 * 1024 * 1024) {
                              toast.error(
                                "File size should be less than 21 MB.",
                              );
                              return;
                            }
                            const fileURL = await dispatch(
                              genericUploadThunk({
                                file,
                                moduleType: row ? "row" : "access",
                              }),
                            );
                            if (fileURL?.payload?.success) {
                              const signedUrl =
                                fileURL?.payload?.data?.signedUrl;
                              setbankGauranteeURL(
                                fileURL?.payload?.data?.objectKey,
                              );
                              if (!productionCheck) {
                                await dispatch(
                                  uploadToS3Thunk({
                                    signedUrl,
                                    file,
                                    contentType: "application/pdf",
                                  }),
                                );
                              }
                              toast.success("Uploaded successfully.");
                              setBankGuaranteeDoc(file.name);
                            }
                            if (!fileURL?.payload?.success) {
                              fileInput.value = "";
                              const fileURLDetails =
                                fileURL?.payload?.details ||
                                fileURL?.payload?.response?.data?.details;
                              toast.error(
                                Array.isArray(fileURLDetails)
                                  ? fileURLDetails?.[0]
                                  : typeof fileURLDetails === "string"
                                    ? fileURLDetails
                                    : "Something Went Wrong!",
                              );
                              return;
                            }
                          }}
                        />
                      </Button>

                      {bankGuaranteeDoc && (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            mt: 1,
                            backgroundColor: "#f5f5f5",
                            px: 1.5,
                            py: 0.8,
                            borderRadius: 2,
                            width: "fit-content",
                          }}
                        >
                          {/* File Name */}
                          <Typography
                            variant="body2"
                            sx={{ overflowWrap: "anywhere" }}
                          >
                            {typeof bankGuaranteeDoc === "string" &&
                              bankGuaranteeDoc}
                          </Typography>

                          {/* Download / Preview Icon */}
                          <IconButton
                            size="small"
                            onClick={() =>
                              handleViewFile(
                                bankGauranteeURL?.split("/")?.pop(),
                                !!row,
                                dispatch,
                              )
                            }
                          >
                            <RemoveRedEye
                              fontSize="small"
                              sx={{ color: "#757575" }}
                            />
                          </IconButton>

                          {/* Remove Icon */}
                          <IconButton
                            size="small"
                            onClick={() => {
                              setBankGuaranteeDoc(null);
                              setbankGauranteeURL(null);
                            }}
                          >
                            <CloseIcon fontSize="small" />
                          </IconButton>
                        </Box>
                      )}
                    </Box>

                    <Typography
                      variant="caption"
                      mt={2}
                      display="block"
                      fontSize={14}
                      className="gray-600"
                    >
                      <b className="red-500">Note:</b> The Performance Bank
                      Guarantee shall remain valid for a period of{" "}
                      {row
                        ? "one (1) year (renew if required)"
                        : "three (3) years"}{" "}
                      and shall be released by the Highway Administrator within
                      thirty (30) days of the grant of regular access
                      permission. In the event the access construction is not
                      completed within the stipulated or extended period, the
                      Highway Administration reserves the right to encash the
                      Bank Guarantee.
                    </Typography>
                  </Paper>
                </Grid>
                <Grid item xs={12} md={4}>
                  {/* ✅ RIGHT SIDE COLUMN */}
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      height: "fit-content",
                    }}
                    className="license-fee-right"
                  >
                    {/* ✅ Case: Utility Type ID = 3 */}
                    {applicantdata?.utility_type_id === 3 && row && (
                      <Box
                        sx={{
                          p: 2,
                          border: "1px dashed #ff8b7a",
                          borderRadius: 2,
                          background: "#fff7f5",
                          mb: 3,
                        }}
                      >
                        <Typography fontWeight={600} fontSize={14} mb={1}>
                          NOC Fee Calculation:
                        </Typography>

                        {provisionalFee?.provisionalFees && (
                          <Typography fontSize={13} mb={1}>
                            A provisional NOC fee of amount ₹
                            {provisionalFee?.provisionalFees?.toLocaleString() ||
                              0}{" "}
                            shall be added to the applicable charges to proceed
                            further.
                          </Typography>
                        )}

                        <Typography fontSize={13}>
                          Final NOC Amount = Utilized NH land area × Circle Rate
                          × 10% × 5 years
                        </Typography>

                        <Typography
                          fontSize={12}
                          color="text.secondary"
                          mt={0.5}
                        >
                          <b>Note</b>: The fee will be calculated for five (5)
                          years in advance.
                        </Typography>

                        <Box
                          sx={{ borderBottom: "1px dotted #ff8b7a", my: 1.5 }}
                        />
                        <Typography fontSize={13}>
                          Final NOC Amount =
                          {/* {FeeDetailsComponent?.finalFeesComponents
                              ?.utilizedNH_land_area || 0}m × Rs */}
                          {/* {FeeDetailsComponent?.finalFeesComponents
                              ?.circleRate || 0}
                            × 10% × 5 = */}
                          <b>
                            {" "}
                            Rs.
                            {provisionalFee?.finalLicenseFees?.toLocaleString() ||
                              0}
                          </b>
                        </Typography>
                      </Box>
                    )}

                    {/* ✅ Case: Utility Type ID = 4 */}
                    {applicantdata?.utility_type_id === 4 && row && (
                      <Box
                        sx={{
                          p: 2,
                          border: "1px dashed #7abaff",
                          borderRadius: 2,
                          background: "#f5faff",
                          mb: 3,
                        }}
                      >
                        <Typography fontWeight={600} fontSize={14} mb={1}>
                          NOC Fee Calculation:
                        </Typography>

                        {provisionalFee?.provisionalFees ? (
                          <Typography fontSize={13} mb={1}>
                            A provisional NOC fee of amount ₹
                            {provisionalFee?.provisionalFees?.toLocaleString() ||
                              0}{" "}
                            shall be added to the applicable charges to proceed
                            further.
                          </Typography>
                        ) : null}

                        <Typography fontSize={13}>
                          Final NOC Amount = Utilized NH land area × Circle Rate
                          of land per unit area × 1.5% per annum
                        </Typography>

                        <Typography
                          fontSize={12}
                          color="text.secondary"
                          mt={0.5}
                        >
                          <b>Note</b>: The fee will be calculated for five (5)
                          years in advance.
                        </Typography>

                        <Box
                          sx={{ borderBottom: "1px dotted #7abaff", my: 1.5 }}
                        />

                        {/* {provisionalFee?.finalLicenseFees ? ( */}
                        <>
                          <Typography fontSize={13}>
                            Final NOC Amount ={" "}
                            {/* {FeeDetailsComponent?.finalFeesComponents
                                ?.utilizedNH_land_area || 0}{" "}
                              m × Rs{" "} */}
                            {/* {FeeDetailsComponent?.finalFeesComponents
                                ?.circleRate || 0}{" "}
                              × 1.5% × 5 ={" "} */}
                            <b>
                              Rs.{" "}
                              {provisionalFee?.finalLicenseFees?.toLocaleString() ||
                                0}
                            </b>
                          </Typography>

                          <Typography
                            fontSize={12}
                            color="text.secondary"
                            mt={0.5}
                          >
                            Note: Subject to minimum of Rs. 10,000/-, with 6%
                            annual increment
                          </Typography>
                        </>
                        {/* ) : (
                          <Typography fontSize={13} color="text.secondary">
                            Loading Final NOC Fee details...
                          </Typography>
                        )} */}
                      </Box>
                    )}

                    {/* ✅ Payment Card */}
                    <Paper
                      sx={{
                        p: 3,
                        borderRadius: 2,
                        backgroundColor: "#F4F4F4",
                        flex: 1,
                        boxShadow: "0px 2px 4px 0px #00000029",
                      }}
                      className="payment-details-card"
                    >
                      <Typography
                        variant="h6"
                        fontWeight={700}
                        mb={2}
                        color="#3A1C73"
                        fontSize={22}
                      >
                        Payment Details
                      </Typography>

                      <Box sx={{ mb: 2 }}>
                        <Typography variant="body2">
                          <b>Applicant Name:</b> {profile?.name}
                        </Typography>
                        <Typography variant="body2">
                          <b>Amenity Name:</b>{" "}
                          {applicantdata?.property_type_name}{" "}
                          {applicantdata?.amenity}
                        </Typography>
                        {access && (
                          <Typography variant="body2">
                            <b>Area:</b> {applicantdata?.location_type_name}
                          </Typography>
                        )}
                        <Typography variant="body2" mb={1}>
                          <b>Location Address:</b> {applicantdata?.address_1}{" "}
                          {applicantdata?.village} {applicantdata?.district}{" "}
                          {applicantdata?.state}
                        </Typography>
                      </Box>

                      <Divider sx={{ mb: 2 }} />

                      <Typography variant="body2" fontWeight={600} mb={1}>
                        Fee Breakup for Provisional NOC
                      </Typography>

                      {Number(provisionalFee?.penaltyFees) > 0 && (
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            mb: 1,
                          }}
                        >
                          <Typography variant="body2">Penalty Fee</Typography>
                          <Typography variant="body2">
                            Rs. {provisionalFee.penaltyFees}.00
                          </Typography>
                        </Box>
                      )}

                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          mb: 1,
                        }}
                      >
                        <Typography variant="body2">
                          Provisional NOC Fee
                        </Typography>
                        <Typography variant="body2">
                          Rs.{" "}
                          {row
                            ? Math.round(
                                Number(provisionalFee?.provisionalFees || 0),
                              )
                            : provisionalFee?.provisionalFees}
                          .00
                        </Typography>
                      </Box>

                      {Number(provisionalFee?.finalLicenseFees) >= 0 && (
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            mb: 1,
                          }}
                        >
                          <Typography variant="body2">Final NOC Fee</Typography>
                          <Typography variant="body2">
                            Rs.{" "}
                            {row
                              ? Math.round(
                                  Number(provisionalFee?.finalLicenseFees || 0),
                                )
                              : provisionalFee?.finalLicenseFees}
                            .00
                          </Typography>
                        </Box>
                      )}

                      <Divider sx={{ mb: 2 }} />

                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          mb: 2,
                        }}
                      >
                        <Typography variant="body1" fontWeight={700}>
                          Total
                        </Typography>
                        <Typography variant="body1" fontWeight={700}>
                          Rs.{" "}
                          {row
                            ? provisionalFee?.finalLicenseFees
                            : provisionalFee?.provisionalFees}
                          .00
                        </Typography>
                      </Box>
                      {(access && provisionalFee?.provisionalFees === 0) ||
                      (row && provisionalFee?.finalLicenseFees === 0) ? (
                        <>
                          <Button
                            variant="contained"
                            fullWidth
                            disabled={
                              !bankGuaranteeNumber ||
                              !bankName ||
                              !bgIssuanceDate ||
                              !bgValidityDate ||
                              !bgClaimDate ||
                              !branchAddress ||
                              !bankGauranteeURL ||
                              !bankGuaranteeDoc
                            }
                            sx={{
                              bgcolor: "#3a1c73",
                              color: "#fff",
                              borderRadius: 100,
                              fontWeight: 600,
                              fontSize: "1rem",
                              py: 1.2,
                              boxShadow: "none",
                              height: 35,
                            }}
                            onClick={() => handleSubmit()}
                          >
                            Proceed To E-Signature
                          </Button>
                          <Typography
                            sx={{
                              bgcolor: "#f7e9e8",
                              color: "#8F1E17",
                              px: 2,
                              py: 1,
                              mt: 2,
                            }}
                            fontSize={13}
                            mb={1}
                          >
                            <strong>Important Notice:</strong> In accordance
                            with the applicable guidelines, the total fee shall
                            be waived for this specific case.
                          </Typography>
                        </>
                      ) : (
                        <Button
                          variant="contained"
                          fullWidth
                          disabled={
                            !applicationId ||
                            !bankGauranteeURL ||
                            !bankGuaranteeNumber ||
                            !bankName ||
                            !bgIssuanceDate ||
                            !bgValidityDate ||
                            !bgClaimDate ||
                            !branchAddress
                          }
                          // disabled={showLoader}
                          sx={{
                            bgcolor: "#3a1c73",
                            color: "#fff",
                            borderRadius: 100,
                            fontWeight: 600,
                            fontSize: "1rem",
                            py: 1.2,
                            boxShadow: "none",
                            height: 35,
                          }}
                          onClick={handlePayNow}
                        >
                          Pay Now
                        </Button>
                      )}
                    </Paper>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>
      </div>
    </Box>
  );
};
